(ns accounts.quovo
  (:require [reagent.core :as r]
            [oops.core :refer [oget]]
            [very.re-frame.core :as rf]
            [css.core :refer [defstyled]]
            [accounts.common :as common]))

(defstyled quovo-modal-s :div
  {:display "grid"
   :min-height "30rem"
   :width "45rem"})

(defstyled loading-message-s :span
  {:text-align "center"})

(defstyled error-message-s :span
  {:text-align "center"})

(defn- create-quovo [{:keys [token on-load]}]
  ((oget js/Quovo "create")
   (clj->js {:onClose #(rf/>evt [:abort-connect-account])
             :userCss (str (.-origin (.-location js/window)) "/assets/quovo-overrides.css")
             :onLoad on-load
             :onSync (fn [err evt]
                       (rf/>evt [:quovo-sync
                                 (js->clj err :keywordize-keys true)
                                 (js->clj evt :keywordize-keys true)]))
             :testInstitutions (when ^:boolean goog.DEBUG true)
             :token token})))

;; we have to do this because quovo is a nightmare to work with: they don't
;; provide any way to destroy an existing handler, but *also* require you to
;; provide a unique token on each invocation ... so the leftover handlers will
;; still receive and invoke their "onLoad" or "onSync" events
(defonce handler (atom nil))
(defonce loaded? (r/atom false))

(defn- quovo-wrapper []
  (r/create-class
    {:display-name "quovo"
     :component-will-mount
     (fn [this]
       (let [props (r/props this)]
         ((oget @handler "open")
        (clj->js {:connection (int (:id props))}))))

     :component-will-update
     (fn [this]
       ((oget @handler "open")
        (clj->js {:connection (:id (r/props this))})))

     :reagent-render
     (fn []
       [:div])}))

(defn ^:export quovo-modal
  "Quovo provides a 'connect' interface for us, all we have to do is acquire a user's
  ui-token, load they're source onto the page, then interace via window.Quovo"
  []
  (let [state (rf/subscribe [:quovo])
        cancel #(rf/>evt [:abort-connect-account])
        connection-to-fix (rf/subscribe [:connection-to-fix])]
    (fn []
      ;; this is stupidly complex because quovo connect is not good -
      ;; on the first render where we have a token and quovo is loaded, create
      ;; the quovo instance and store it at a module-global level. for each
      ;; successive render, we have to wait until that handler's on-load fn
      ;; triggers before we stop showing the "loading quovo" message -- this
      ;; happens because quovo takes 2ish seconds to load even after its been
      ;; initialized on the page
      (when-not @handler
        (if (and (:script-loaded? @state)
                 (:token @state))
          (reset! handler (create-quovo {:token (:token @state)
                                         :on-load (fn []
                                                    (reset! loaded? true))}))))
      ;; note this is kind of a mess: if we were unable to fetch a token to load
      ;; the quovo connect feature, show some error message. if quovo's feature
      ;; hasn't been loaded yet, show a loading message. if the feature HAS been
      ;; loaded, render it (and occasionally there might be data to pass into
      ;; the feature, such as when we need to repair a connection).
      (cond
        (:unavailable? @state)
        [quovo-modal-s
         [common/modal-with-header {:title "Connect Accounts"
                                    :on-cancel cancel}
          [error-message-s "There was an issue loading the account connector. Please try again later."]]]

        (false? @loaded?)
        [quovo-modal-s
         [common/modal-with-header {:title "Connect Accounts"
                                    :on-cancel cancel}
          [loading-message-s "Loading the account connector..."]]]

        :else
        [quovo-wrapper @connection-to-fix]
        ))))
